import playerStore from '../../store/PlayerStore';
import tableStore from '../../store/TableStore';
import { WEvent } from './WEvent';

export class WMyBotEvent extends WEvent {
  pid: string;
  uniqueId: string;
  prStats: string;
  mttPosition: number;

  constructor(event: WMyBotEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> =>
    tableStore.findActiveTableById(this.tableId).then(table => {
      table.setPlayers(
        playerStore.modifyPlayers(table.players, this.pid, player => {
          player.myBot = true;
          player.uniqueId = this.uniqueId;
          player.prStats = this.prStats;
          player.mttPosition = this.mttPosition;
        }),
      );
      tableStore.changeFilterState();
    });
}
